import scope from 'scope-css';
import 'regenerator-runtime/runtime';

import './index.scss';
import Publisher from '../publisher/app';
import mergeThemeAndConfig from '../theme-utils/';

const highlighters = document.querySelector('meta[name="highlighters"]').getAttribute('content');
const style = JSON.parse(document.querySelector('meta[name="highlighters"]').getAttribute('content'));

const themeSheet = document.createElement('style');
document.head.appendChild(themeSheet);

mergeThemeAndConfig({}, style.theme).then((typography) => {
  const css = scope(typography.toString(), '#root');
  themeSheet.innerHTML = css;
});


window.publisher = new Publisher('root', {
  brand: false,
  help: true,
  highlighters: JSON.parse(highlighters),
});
